/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ workouts: NonNullable<unknown>, names: NonNullable<unknown> }} History_Transfer_FoundInputs */

const en_us2_history_transfer_found = /** @type {(inputs: History_Transfer_FoundInputs) => LocalizedString} */ (i) => {
	if ((i?.workouts === 1 || i?.workouts === "1")) return /** @type {LocalizedString} */ (`1 workout with ${i?.names} different exercises.`);
	return /** @type {LocalizedString} */ (`${i?.workouts} workouts with ${i?.names} different exercises.`)
	
};

const pt_br2_history_transfer_found = /** @type {(inputs: History_Transfer_FoundInputs) => LocalizedString} */ (i) => {
	if ((i?.workouts === 1 || i?.workouts === "1")) return /** @type {LocalizedString} */ (`1 treino com ${i?.names} exercícios diferentes.`);
	return /** @type {LocalizedString} */ (`${i?.workouts} treinos com ${i?.names} exercícios diferentes.`)
	
};

const es_419_history_transfer_found = /** @type {(inputs: History_Transfer_FoundInputs) => LocalizedString} */ (i) => {
	if ((i?.workouts === 1 || i?.workouts === "1")) return /** @type {LocalizedString} */ (`1 entrenamiento con ${i?.names} ejercicios diferentes.`);
	return /** @type {LocalizedString} */ (`${i?.workouts} entrenamientos con ${i?.names} ejercicios diferentes.`)
	
};

const pt_pt2_history_transfer_found = /** @type {(inputs: History_Transfer_FoundInputs) => LocalizedString} */ (i) => {
	if ((i?.workouts === 1 || i?.workouts === "1")) return /** @type {LocalizedString} */ (`1 treino com ${i?.names} exercícios diferentes.`);
	return /** @type {LocalizedString} */ (`${i?.workouts} treinos com ${i?.names} exercícios diferentes.`)
	
};

const fr_fr2_history_transfer_found = /** @type {(inputs: History_Transfer_FoundInputs) => LocalizedString} */ (i) => {
	if ((i?.workouts === 1 || i?.workouts === "1")) return /** @type {LocalizedString} */ (`1 séance avec ${i?.names} exercices différents.`);
	return /** @type {LocalizedString} */ (`${i?.workouts} séances avec ${i?.names} exercices différents.`)
	
};

const de_de2_history_transfer_found = /** @type {(inputs: History_Transfer_FoundInputs) => LocalizedString} */ (i) => {
	if ((i?.workouts === 1 || i?.workouts === "1")) return /** @type {LocalizedString} */ (`1 Training mit ${i?.names} verschiedenen Übungen.`);
	return /** @type {LocalizedString} */ (`${i?.workouts} Trainings mit ${i?.names} verschiedenen Übungen.`)
	
};

const it_it2_history_transfer_found = /** @type {(inputs: History_Transfer_FoundInputs) => LocalizedString} */ (i) => {
	if ((i?.workouts === 1 || i?.workouts === "1")) return /** @type {LocalizedString} */ (`1 allenamento con ${i?.names} esercizi diversi.`);
	return /** @type {LocalizedString} */ (`${i?.workouts} allenamenti con ${i?.names} esercizi diversi.`)
	
};

/**
* | workouts | output |
* | --- | --- |
* | "1" | "1 workout with {names} different exercises." |
* | * | "{workouts} workouts with {names} different exercises." |
*
* @param {History_Transfer_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_found = /** @type {((inputs: History_Transfer_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_found(inputs)
	if (locale === "es-419") return es_419_history_transfer_found(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_found(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_found(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_found(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_found(inputs)
	return en_us2_history_transfer_found(inputs)
});
export { history_transfer_found as "history-transfer.found" }